Trix.config.blockAttributes.heading1 = {
    tagName: "h2",
    terminal: true,
    breakOnReturn: true,
    group: false
}